
// Helpful functions for pure JS

// Hack to get the REAL window size
document.querySelector('body, html').style.overflow = 'hidden'
document.querySelector('body, html').style.overflow = 'visible'

function getWindowScroll (left = false) {
  let supportPageOffset = window.pageXOffset !== undefined,
      isCSS1Compat = ((document.compatMode || "") === "CSS1Compat")
  if (left) {
    return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft
  } else {
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop
  }
}

function getOffset (element, horizontal = false) {
  if(!element) return 0
  return getOffset(element.offsetParent, horizontal) + (horizontal ? element.offsetLeft : element.offsetTop)
}

function getWindowSize (width = false) {
  if (width) {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  } else {
    return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  }
}

function fadeIn (target, duration = 400) {
  target.style.opacity = 0
  target.style.display = 'block'
  let opacity
  function show(){
    opacity = Number.parseFloat(window.getComputedStyle(target).opacity)
    if (opacity < 1) {
      opacity = 0.01 + opacity
      target.style.opacity = opacity
      setTimeout(show, duration/100)
    }
  }
  show()
}

function fadeOut (target, duration = 400) {
  target.style.opacity = 1
  let opacity
  function hide(){
    opacity = Number.parseFloat(window.getComputedStyle(target).opacity)
    if (opacity > 0){
      opacity = opacity - 0.01
      target.style.opacity = opacity
      setTimeout(hide, duration/100)
    } else {
      target.style.display = 'none'
      target.style.opacity = 1
    }
  }
  hide()
}

function slideUp (target, duration = 400) {
  target.style.transitionProperty = 'height, margin, padding'
  target.style.transitionDuration = duration + 'ms'
  target.style.boxSizing = 'border-box'
  target.style.height = target.offsetHeight + 'px'
  target.offsetHeight
  target.style.overflow = 'hidden'
  target.style.height = 0
  target.style.paddingTop = 0
  target.style.paddingBottom = 0
  target.style.marginTop = 0
  target.style.marginBottom = 0
  window.setTimeout( () => {
    target.style.display = 'none'
    target.style.removeProperty('height')
    target.style.removeProperty('padding-top')
    target.style.removeProperty('padding-bottom')
    target.style.removeProperty('margin-top')
    target.style.removeProperty('margin-bottom')
    target.style.removeProperty('overflow')
    target.style.removeProperty('transition-duration')
    target.style.removeProperty('transition-property')
  }, duration)
}

function slideDown (target, duration = 400) {
  target.style.removeProperty('display')
  let display = window.getComputedStyle(target).display
  if (display === 'none')
    display = 'block'
  target.style.display = display
  let height = target.offsetHeight
  target.style.overflow = 'hidden'
  target.style.height = 0
  target.style.paddingTop = 0
  target.style.paddingBottom = 0
  target.style.marginTop = 0
  target.style.marginBottom = 0
  target.offsetHeight
  target.style.boxSizing = 'border-box'
  target.style.transitionProperty = "height, margin, padding"
  target.style.transitionDuration = duration + 'ms'
  target.style.height = height + 'px'
  target.style.removeProperty('padding-top')
  target.style.removeProperty('padding-bottom')
  target.style.removeProperty('margin-top')
  target.style.removeProperty('margin-bottom')
  window.setTimeout( () => {
    target.style.removeProperty('height')
    target.style.removeProperty('overflow')
    target.style.removeProperty('transition-duration')
    target.style.removeProperty('transition-property')
  }, duration)
}

function slideToggle (target, duration = 400) {
  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration)
  } else {
    return slideUp(target, duration)
  }
}

export { getWindowScroll }
export { getOffset }
export { getWindowSize }
export { fadeIn }
export { fadeOut }
export { slideUp }
export { slideDown }
export { slideToggle }

require('./popup')
require('./select')
require('./slider')
require('./img-zoomer')



// Expanders
document.querySelectorAll('.expander-button').forEach(function(node) {
  node.addEventListener('click', function(e) {
    if (node.closest('.expander').classList.contains('opened')) {
      node.closest('.expander').classList.remove('opened')
      node.closest('.expander').querySelector('.expander-hidden').setAttribute('style','')
    } else {
      document.querySelectorAll('.expander').forEach(function(node2) {
        node2.closest('.expander').classList.remove('opened')
        node2.closest('.expander').querySelector('.expander-hidden').setAttribute('style','')
      })
      node.closest('.expander').classList.add('opened')
      setTimeout(function(){
        node.closest('.expander').querySelector('.expander-hidden').style.maxHeight = node.closest('.expander').querySelector('.expander-hidden-inner').offsetHeight + 'px'
        let offset = getOffset(node.closest('.expander')) - 100
        window.scroll({
          top: offset,
          left: 0,
          behavior: 'smooth'
        })
      }, 500)
    }
  })
})



// Fixed header

function fixedNav () {
  if (getWindowScroll() > 20) {
    document.querySelector('.header').classList.add('fixed')
  } else {
    document.querySelector('.header').classList.remove('fixed')
  }
}

fixedNav()
window.addEventListener('scroll', fixedNav)
window.addEventListener('resize', fixedNav)
